export default __webpack_public_path__ + "static/media/Butterflies.41e72ab0.jpeg";